import { useRecoilState, useRecoilValue } from 'recoil';
import { beaconSelector } from '../recoil/selector';
import useBeacon from '../hooks/useBeacon';
import { useEffect, useMemo, useState } from 'react';
import { PAGE_NM, PLACEMENT_TYPE, SORT_KEY } from '../types/types';
import * as Atom from '../recoil';
import useControlBridge from '../hooks/useControlBridge';
import { useBaseParam } from '../hooks/useBaseParam';
import useNav from '../hooks/useNav';
import { fetchCustTotalProductList } from '../../infra/api/fetchCustTotalProductList';
import { fetchMonthlyRequestDetail } from '../../infra/api/fetchMonthlyRequestDetail';
import { useBridge } from '../hooks/useBridge';
import { useLocation, useParams } from 'react-router-dom';
import HOME_BANNER3 from '../../assets/images/banner/banner-noti3@2x.png';
import { useBanner } from '../hooks/useBanner';
import { filter } from '../recoil';

const useResult = () => {
  const { navigate, navigateMain } = useNav();
  const [personal] = useRecoilState(Atom.personalInfo);
  const [, setLoanList] = useRecoilState(Atom.loanList);
  const [baseContents] = useRecoilState(Atom.baseContents);

  const [isBridgeModal, setIsBridgeModal] = useState<boolean>(false);
  const [todayLoanList, setTodayLoanList] = useState<any>(undefined);
  const [isOpenFilter, setOpenFilter] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useRecoilState(filter);
  const [sortValue, setSortValue] = useState<number>(SORT_KEY.LOW_RATE);
  const [categoryValues, setCategoryValues] = useState<
    typeof categoryItems[number]['category'][]
  >(['전체']);
  const [shouldBlock, setShouldBlock] = useState<any>(true);

  const sortingItems = [
    { label: '한도순', value: SORT_KEY.MAX_AMOUNT },
    { label: '금리순', value: SORT_KEY.LOW_RATE },
  ];
  const categoryItems = [
    { category: '전체' },
    { category: '신용대출', chips: ['신용대출', '주택보유자', '사업자 전용'] },
    { category: '정부지원', chips: ['정부지원'] },
    { category: '담보대출', chips: ['본인명의 자동차', '후순위 담보'] },
    {
      category: '우수대부업',
      chips: ['회생·파산자 대상', 'DSR규제 미적용', '우수대부업'],
    },
    { category: '비상금', chips: ['비상금 대출'] },
  ] as const;
  const activeCategories = useMemo(() => {
    if (!Array.isArray(todayLoanList?.allList)) return [];

    return categoryItems.filter((categoryItem: any) => {
      if (categoryItem.category === '전체') return true;
      if (!('chips' in categoryItem) || !categoryItem.chips) return false;

      return todayLoanList.allList.some((item: any) =>
        item.eventChip?.some((chip: any) =>
          categoryItem.chips.includes(chip.text),
        ),
      );
    });
  }, [todayLoanList?.allList]);
  const [monthlyDetail, setMonthlyDetail] = useState<any>({});
  const [, setNotiDetailInfo] = useRecoilState(Atom.notiDetailInfo);
  const location = useLocation();
  const before: any = location?.state;
  const sendBeaconPrdlistSucc = (prdlist: number) => {
    beacon.sendPrdlistSucc({
      properties: {
        prdlist,
      },
    });
  };
  const sendBeaconClkBtnRate = (btnNm: string) => {
    beacon.sendClkBtnRate({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBtnLimit = (btnNm: string) => {
    beacon.sendClkBtnLimit({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBtnFilter = (btnNm: string) => {
    beacon.sendClkBtnFilter({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBnrNotiAutoRec = (btnNm: string) => {
    beacon.sendClkBnrNotiAutoRec({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBnrNotiSchAlrtApp = (btnNm: string) => {
    beacon.sendClkBnrNotiSchAlrtApp({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBtnEbmpOutlink = (btnNm: string) => {
    beacon.sendClkBtnEbmpOutlink({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBnrBnrPromotion = (btnNm: string) => {
    beacon.sendClkBnrBnrPromotion({
      properties: {
        btnNm,
        promotion_type: 'is',
        promotion_str_dt: '2023-04-17',
        promotion_end_dt: '2023-05-31',
        promotion_seq: '2',
      },
    });
  };

  const navigateNoti = (v?: string) => {
    navigate(`/${v}`);
  };

  const getMonthlyRequestDetail = useBaseParam(fetchMonthlyRequestDetail, {
    custSeq: personal.custSeq,
  });

  const initNotiInfo = async (val: string) => {
    const res = await getMonthlyRequestDetail();
    setMonthlyDetail(res.data.result);
    setNotiDetailInfo(res.data.result);
  };
  useEffect(() => {
    if (!!personal.custSeq) {
      initNotiInfo(personal.custSeq);
    }
  }, [personal.custSeq]);

  const getMonthlyBannerContent = () => {
    const monthlyBannerContents = [
      {
        message: `${monthlyDetail?.monthlyRequestRegDate}에 신청하신 정기 알림 결과입니다.\n 나의 입력 정보 확인하기 >`,
        handler: () => {
          sendBeaconClkBnrNotiAutoRec('정기 알림 결과 배너');
          navigateNoti('notiPreInforms');
        },
      },
      {
        message: `매달 변하는 나의 금리/한도를 1초 만에?\n 정기 알림 신청하기 >`,
        handler: () => {
          sendBeaconClkBnrNotiSchAlrtApp('정기 알림 신청 배너');
          navigateNoti('notiPreReg');
        },
      },
    ];

    // 자동 가심사 결과인지 여부
    const isAutoPreReq = todayLoanList?.preRequestInfoData?.monthlyYn === 'Y';

    // 정기 알림 신청자 여부
    const isMonthlyRequestYn = monthlyDetail?.monthlyRequestYn === 'Y';

    if (isAutoPreReq && isMonthlyRequestYn) return monthlyBannerContents[0];
    if (!isMonthlyRequestYn) return monthlyBannerContents[1];
  };

  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.RESULT,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const openFilter = () => {
    setOpenFilter(true);
  };
  const confirmFilter = (value: any) => {
    setOpenFilter(false);
    setFilterValue({ ...value });
  };
  const closeFilter = () => {
    setOpenFilter(false);
  };
  const changeSort = (value: any) => {
    if (value === sortValue) return;
    setSortValue(value);
  };
  const changeCategories = (
    value: typeof categoryItems[number]['category'],
  ) => {
    if (categoryValues.includes(value)) {
      if (value === '전체') {
        setCategoryValues(['전체']);
      } else {
        const filtered = categoryValues.filter((v) => v !== value);
        if (filtered.length === 0) {
          setCategoryValues(['전체']);
        } else {
          setCategoryValues(filtered);
        }
      }
    } else {
      if (value === '전체') {
        setCategoryValues(['전체']);
      } else {
        const filtered = categoryValues.filter((v) => v !== '전체');
        setCategoryValues([...filtered, value]);
      }
    }
  };

  const getFilteredList = () => {
    if (!Array.isArray(todayLoanList?.allList)) return;
    let filtered = todayLoanList?.allList?.map((item: any) => ({
      ...item,
    }));
    if (filterValue.interest !== undefined && filterValue.interest !== null) {
      filtered = filtered.filter(
        (item: any) => item.interestRate <= filterValue.interest,
      );
    }
    if (filterValue.limit !== undefined && filterValue.limit !== null) {
      filtered = filtered.filter((item: any) => {
        return item.amount >= filterValue.limit;
      });
    }
    filtered = filtered.sort((a: any, b: any) => {
      if (sortValue === SORT_KEY.LOW_RATE) {
        return a.interestRate - b.interestRate || b.amount - a.amount;
      } else if (sortValue === SORT_KEY.MAX_AMOUNT) {
        return b.amount - a.amount || a.interestRate - b.interestRate;
      }
    });
    filtered = filtered.filter((item: any) => {
      if (categoryValues.includes('전체')) return true;
      const categories = categoryItems.filter(({ category }) =>
        categoryValues.includes(category),
      );
      const chips = categories.flatMap(
        (category) => (category as { chips?: string[] }).chips || [],
      );
      if (chips.length === 0) return true;
      const hasChip = item.eventChip.some((chip: any) =>
        chips.includes(chip.text),
      );
      return hasChip;
    });
    return filtered;
  };
  const { closeWebview } = useControlBridge();
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const useMtgLoan = useRecoilValue(Atom.useMtgLoan);

  const closeCreditLoan = () => {
    setShouldBlock(false);
    setTimeout(() => {
      if (useMtgLoan) navigateMain();
      else closeWebview();
    }, 100);
  };

  const alertContents = [
    {
      message: '내일은 대출조건이 달라질 수 있어요\n 그래도 나가시겠어요?',
      confirmText: '예',
      handleClickConfirm: () => closeCreditLoan(),
      cancelText: '아니요',
      handleClickCancel: () => setShowAlert(false),
    },
    {
      message: '오늘은 신청할 수 있는 상품이 없어요.\n내일 다시 확인해 주세요.',
      confirmText: '확인',
      handleClickConfirm: () => closeCreditLoan(),
    },
  ];

  const condition = { custSeq: personal.custSeq };
  const setBaseCustProductInfoListDay = useBaseParam(
    fetchCustTotalProductList,
    condition,
  );
  const getCustProductInfoListDay = async () => {
    const res: any = await setBaseCustProductInfoListDay();
    const temp = res?.data?.result;

    if (!temp) {
      setTodayLoanList(() => {
        return {};
      });
      return;
    }
    setLoanList((prev: any) => {
      return {
        ...prev,
        preRequestInfoChk: temp?.preRequestInfoChk,
        dayAgo: temp?.dayAgo,
      };
    });
    setTodayLoanList(() => {
      // allProductItemList가 없으면 빈배열로 들어오기때문에 가심사결과유무 판단
      sendBeaconPrdlistSucc(temp?.allProductItemList?.length ?? 0);
      return {
        bestList: [
          {
            key: 'limit' + temp?.maxAmountProductItem?.productInfo?.productSeq,
            state: 'limit',
            logoImgUrl: temp?.maxAmountProductItem?.productInfo?.logoImgUrl,
            amountText:
              temp?.maxAmountProductItem?.custPreProductInfo?.amountText,
            interestRate:
              temp?.maxAmountProductItem?.custPreProductInfo?.interestRate,
            productNm: temp?.maxAmountProductItem?.productInfo?.productNm,
            preRequestDtlNo:
              temp?.maxAmountProductItem?.custPreProductInfo?.preRequestDtlNo,
            requestSeq:
              temp?.maxAmountProductItem?.custRequestProductInfo?.requestSeq,
            chip: temp?.maxAmountProductItem?.custRequestProductInfo?.status
              ? [
                  {
                    type:
                      temp?.maxAmountProductItem?.custRequestProductInfo
                        ?.status === '01'
                        ? 'apply'
                        : temp?.maxAmountProductItem?.custRequestProductInfo
                            ?.status === '02'
                        ? 'examine'
                        : temp?.maxAmountProductItem?.custRequestProductInfo
                            ?.status === '03'
                        ? 'complete'
                        : '',
                  },
                ]
              : [],
          },
          {
            key:
              'interest' +
              temp?.minInterestProductItem?.productInfo?.productSeq,
            state: 'interest',
            logoImgUrl: temp?.minInterestProductItem?.productInfo?.logoImgUrl,
            amountText:
              temp?.minInterestProductItem?.custPreProductInfo?.amountText,
            interestRate:
              temp?.minInterestProductItem?.custPreProductInfo?.interestRate,
            productNm: temp?.minInterestProductItem?.productInfo?.productNm,
            preRequestDtlNo:
              temp?.minInterestProductItem?.custPreProductInfo?.preRequestDtlNo,
            requestSeq:
              temp?.minInterestProductItem?.custRequestProductInfo?.requestSeq,
            chip: temp?.minInterestProductItem?.custRequestProductInfo?.status
              ? [
                  {
                    type:
                      temp?.minInterestProductItem?.custRequestProductInfo
                        ?.status === '01'
                        ? 'apply'
                        : temp?.minInterestProductItem?.custRequestProductInfo
                            ?.status === '02'
                        ? 'examine'
                        : temp?.minInterestProductItem?.custRequestProductInfo
                            ?.status === '03'
                        ? 'complete'
                        : '',
                  },
                ]
              : [],
          },
        ],
        allList: temp?.allProductItemList.map((item: any) => {
          return {
            key: item?.productInfo?.productSeq,
            benefitText: '',
            stateChip: item?.custRequestProductInfo?.status
              ? [
                  {
                    type:
                      item?.custRequestProductInfo?.status === '01'
                        ? 'apply'
                        : item?.custRequestProductInfo?.status === '02'
                        ? 'examine'
                        : item?.custRequestProductInfo?.status === '03'
                        ? 'complete'
                        : '',
                  },
                ]
              : [],
            eventChip: item?.productInfo?.hashTagList.map((item: any) => {
              return {
                type: 'event',
                text: item.tagNm,
                backgroundColor: item.backgroundColor,
                color: item.color,
                order: item.dispOrd,
              };
            }),
            preRequestDtlNo: item?.custPreProductInfo?.preRequestDtlNo,
            requestSeq: item?.custRequestProductInfo?.requestSeq,
            amount: item?.custPreProductInfo?.amount,
            limit: item?.custPreProductInfo?.interestRate,
            logoImgUrl: item?.productInfo?.logoImgUrl,
            companyNm: item?.productInfo?.compNm,
            productNm: item?.productInfo?.productNm,
            limitValue: item?.custPreProductInfo?.amountText,
            interestRate: item?.custPreProductInfo?.interestRate,
          };
        }),
        cancelList: temp?.cancelProductList.map((item: any) => {
          return {
            key: item?.productInfo?.productSeq,
            logoImgUrl: item?.productInfo?.logoImgUrl,
            companyNm: item?.productInfo?.compNm,
            productNm: item?.productInfo?.productNm,
            state: 'disabled',
          };
        }),
        rejectList: temp?.rejectProductItemList.map((item: any) => {
          return {
            key: item?.productInfo?.productSeq,
            logoImgUrl: item?.productInfo?.logoImgUrl,
            companyNm: item?.productInfo?.compNm,
            productNm: item?.productInfo?.productNm,
            state: 'disabled',
          };
        }),
        preRequestInfoData: temp?.preRequestInfoData,
        todayRequested: temp?.preRequestInfoChk && temp?.dayAgo === 0,
        toDayRemainTime: temp?.toDayRemainTime,
      };
    });
  };

  const navigateDetail = (requestSeq: any, preRequestDtlNo: any) => {
    navigate(`/detail/${requestSeq ?? 0}/${preRequestDtlNo}`);
  };
  const { media } = useParams();
  const br: any = useBridge();

  const navigateDA = (media?: string) => {
    setIsBridgeModal(false);
    // todo navigateByLinkType
    if (media === 'skt') {
      // 임시로 임시로 A007BC02
      //const trackCdType = 'A007BC04'; // 기존 코드 : A007BA02
      const trackCdType = 'A007BA01';
      br?.requestAddService({
        type: 'EBMP',
        url:
          process.env.REACT_APP_EBMP_SKT_URI +
          `?extraParam=3&extraParam2=${trackCdType}`,
      });
    } else if (media === 'kt') {
      // const srcCd = 'D007BC04'; // 기존 코드 : D007BA02
      const srcCd = 'D007BA01';
      br?.requestAddService({
        type: 'EBMP',
        url: process.env.REACT_APP_EBMP_KT_URI + `?src_cd=${srcCd}`,
      });
    } else {
      //const srcCd = 'B007BC04'; // 기존 코드 : B007BC02
      const srcCd = 'B007BA01';
      const redirectYn = 'Y';
      br?.requestAddService({
        type: 'EBMP',
        url: `?tabSeq=1&track_cd_type=${srcCd}&redirectYn=${redirectYn}`,
      });
    }
  };

  const onClickNaviButton = () => {
    setIsBridgeModal(true);
  };

  useEffect(() => {
    if (personal?.custSeq) {
      getCustProductInfoListDay();
    }
  }, []);

  // banner
  const {
    isLoading: isLoadingBannerList,
    bannerList,
    hasBannerList,
  } = useBanner(
    media || '',
    PLACEMENT_TYPE.loan_pre_request_result,
    baseContents.serverTime,
  );

  return {
    beacon,
    isLoading: todayLoanList === undefined,
    todayLoanList,
    pageName: PAGE_NM.RESULT,
    closeWebview,
    media,
    showAlert,
    shouldBlock,
    setShowAlert,
    setShouldBlock,
    alertContent: todayLoanList ? alertContents[0] : alertContents[1],
    navigateDetail,
    navigateDA,
    regDate: personal.regDate,
    custNm: personal.custNm,
    maxAmount: todayLoanList?.bestList.filter(
      (item: any) => item.state === 'limit',
    )[0].amountText,
    filteredList: getFilteredList(),
    filterValue,
    isOpenFilter,
    sortingItems,
    sortValue,
    categoryItems: activeCategories,
    categoryValues,
    openFilter,
    confirmFilter,
    closeFilter,
    changeSort,
    changeCategories,
    hasBestList: todayLoanList?.allList?.length > 0,
    hasAllList: todayLoanList?.allList?.length > 0,
    // hasAllList: false,
    hasCancelList: todayLoanList?.cancelList?.length > 0,
    // hasCancelList: true,
    hasRejectList: todayLoanList?.rejectList?.length > 0,
    monthlyBannerContent: getMonthlyBannerContent(),
    toDayRemainTime: todayLoanList?.toDayRemainTime?.split(':'),
    before,
    sendBeaconPrdlistSucc,
    sendBeaconClkBtnRate,
    sendBeaconClkBtnLimit,
    sendBeaconClkBtnFilter,
    sendBeaconClkBtnEbmpOutlink,
    sendBeaconClkBnrBnrPromotion,
    onClickNaviButton,
    isBridgeModal,
    promotionBanner3: HOME_BANNER3,

    bannerList: bannerList.map((item: any) => ({
      ...item,
      // todo send beacon - 기획 정의 x
      beacon: {
        click: () =>
          item.bannerSeq === 0
            ? sendBeaconClkBnrBnrPromotion('프로모션 배너')
            : () => {},
        view: () => {},
      },
    })),
    hasBannerList,
  };
};

export default useResult;
